import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    currentUser: {},
    csrf: null,
    invoices: [],
    comprobantes: []
  },
  getters: {
    // isAdmin (state) {
    //   return state.currentUser && state.currentUser.role === 'admin'
    // },
    // isManager (state) {
    //   return state.currentUser && state.currentUser.role === 'manager'
    // },
    currentUserId (state) {
      return state.currentUser && state.currentUser.id
    }
  },
  mutations: {
    setCurrentUser (state, { currentUser, csrf }) {
      state.currentUser = currentUser
      state.signedIn = true
      state.csrf = csrf
    },
    unsetCurrentUser (state) {
      state.currentUser = {}
      state.signedIn = false
      state.csrf = null
    },
    refresh (state, csrf) {
      state.signedIn = true
      state.csrf = csrf
    }
  },
  plugins: [createPersistedState()]
})

// store.commit('setCurrentUser', { currentUser: meResponse.data, csrf: response.data.csrf }))
